import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { useState, type ReactElement, type ReactNode } from 'react';

import { createQueryClient } from '@/lib/queryClient';

export function AppProviders({
  children,
  client,
}: {
  children: ReactNode;
  client?: QueryClient;
}): ReactElement {
  // 再レンダリングのたびにクライアントを作り直さない（キャッシュが飛ぶため）
  const [defaultClient] = useState(createQueryClient);
  return <QueryClientProvider client={client ?? defaultClient}>{children}</QueryClientProvider>;
}
